import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";
import HashtagString from "../core/HashtagString";
import { postKey } from "utils/assets_exports/images";

export type DemoActivityItem = {
    id: number;
    svg: string;
    date: string;
    title: String;
    label: string;
    details: string;
    isIncident?: boolean;
};

export type ActivityItemProps = CustomComponentProps & {
    item: DemoActivityItem;
};

const ActivityItem = ({ item, className, style }: ActivityItemProps) => {
    return (
        <div
            className={`follow-user-li notification-item mb-20 d-flex w-full ${className}`}
            style={style}
        >
            <div
                className="svg-circle big-circle d-flex flex-j-center flex-a-center"
                style={{ height: "38px", width: "38px" }}
            >
                {item.svg == "post" ? (
                    <img
                        src={postKey}
                        alt="post"
                        className="round-img"
                        style={{
                            width: "22px",
                            height: "22px",
                            border: "none",
                            boxShadow: "none"
                        }}
                    />
                ) : (
                    <SVG svg={item.svg} size={24} className="cursor-default" />
                )}
            </div>
            <div className="follow-user-li-text d-flex flex-col flex-a-start flex-j-center pl-10 w-full">
                <div className="d-flex flex-j-between flex-a-center gap-5 mb-10 w-full">
                    <h3 className="dark-grey-text white-text">{item.title}</h3>

                    <div className="d-flex flex-col flex-j-between flex-a-center gap-5">
                        <span className="momeento-p ml-auto fs-9em black-text white-text">
                            2 min ago
                        </span>
                        <SVG svg="x" size={18} className="red-svg" />
                    </div>
                </div>

                <div className="d-flex flex-j-start flex-a-center gap-5 mb-10">
                    {item.isIncident ? (
                        <SVG
                            svg="i-triangle"
                            size={12}
                            className="red-svg cursor-default"
                        />
                    ) : (
                        ""
                    )}
                    <HashtagString
                        content={item.label}
                        className="momeento-p light-grey-text"
                    />
                </div>

                <div className="d-flex flex-j-start flex-a-center gap-5 mb-10">
                    {item.isIncident ? (
                        <SVG
                            svg="map-pointer"
                            size={12}
                            className="blue-white-svg cursor-default"
                        />
                    ) : (
                        ""
                    )}
                    <HashtagString
                        content={item.details}
                        className="momeento-p light-grey-text"
                    />
                </div>
            </div>
        </div>
    );
};

export default ActivityItem;
